import React, { useContext, useEffect, useState } from "react";
import './sidebar.style.scss';
import lgoLogo from '../../../assets/SVG/LGO.svg';
import { AccountContext } from "../../../Contexts/main.context";
import locationIcon from '../../../assets/ICONS/documents-papers-with-text-lines-svgrepo-com.svg';
import notFoundIcon from '../../../assets/ICONS/not-found-16-svgrepo-com.svg';
import customerIcon from '../../../assets/ICONS/customer-source-line-svgrepo-com.svg';
import mapIcon from '../../../assets/ICONS/map-pin-svgrepo-com.svg';
import EditMapIcon from '../../../assets/ICONS/map-pin-alt-svgrepo-com.svg';
import accountIcon from '../../../assets/ICONS/sign-out-svgrepo-com.svg';
import editIcon from '../../../assets/ICONS/LGO_Edit.svg';
import addIcon from '../../../assets/ICONS/add-circle-svgrepo-com.svg';
import followIcon from '../../../assets/ICONS/search-globe-svgrepo-com.svg';
import changeIcon from '../../../assets/ICONS/request-added-svgrepo-com.svg';
import lgoGroup from '../../../assets/ICONS/LGO_Group.svg';


const SideBar = ({ width = "250px" }) => {

     const { actionButtons, updateActiveOutlet, activeOutlet } = useContext(AccountContext);

     const [userAccount, updateMyAccount] = useState([]);

     useEffect(() => {
          if (actionButtons && actionButtons.length > 0) {
               const selectedBtn = actionButtons?.find(btn => btn.selected);
               updateActiveOutlet(selectedBtn.action);
          }
          // eslint-disable-next-line
     }, [actionButtons]);

     useEffect(() => {
          if (!actionButtons || !activeOutlet) return;
          const match = actionButtons.find(btn => btn.action === activeOutlet);
          if (match && !match.selected) {
               actionButtons.forEach(btn => btn.selected = false);
               match.selected = true;
          }
     }, [activeOutlet]);



     useEffect(() => {
          const token = localStorage.getItem('LGOUser');
          // Decode JWT payload
          let payload = null;
          if (token) {
               try {
                    const base64Payload = token.split('.')[1];
                    payload = JSON.parse(atob(base64Payload));
                    updateMyAccount(payload);
               } catch (e) {
                    console.error("Failed to decode JWT token:", e);
               }
          }
     }, []);

     const setTheSideButton = (inval) => {
          // Mark the selected one
          const match = actionButtons?.find(el => el.action === inval.action);
          actionButtons?.forEach(element => {
               element.selected = false;
          });
          if (match) {
               match.selected = true;
               updateActiveOutlet(inval.action);
          } else {
               console.warn("No matching action found for:", inval);
               updateActiveOutlet(inval);
          }
     };

     const iconMap = (icon) => {
          switch (icon) {
               case 'locations': return locationIcon;
               case 'customer': return customerIcon;
               case 'map': return mapIcon;
               case 'edit': return EditMapIcon;
               case 'editCustomer': return editIcon;
               case 'add': return addIcon;
               case 'follow': return followIcon;
               case 'change': return changeIcon;
               default: return notFoundIcon;
          }
     };

     return (
          <div className="sidebar-wrapper" style={{ width: width }}>
               <div className="bg-navy w-100 text-center" style={{ height: "70px" }}>
                    <img
                         src={lgoLogo}
                         style={{ maxHeight: "45px", marginBottom: "15px", marginTop: "10px" }}
                         alt="LGO Logo"
                    />
               </div>

               {actionButtons && actionButtons.length > 0 &&
                    actionButtons.map((btn, index) => (
                         <div className="col-48" key={index}>
                              <div onClick={() => setTheSideButton(btn)}
                                   className={`action-button d-flex align-items-center w-100 text-center py-3 ${btn.selected ? 'bg-warning' : ''}`}>

                                   <div className="col-14 text-center">
                                        <img
                                             src={iconMap(btn.icon) || notFoundIcon} // fallback if not found
                                             alt={btn.icon}
                                             height="35px"
                                        />
                                   </div>
                                   <div className="flex-grow-1 text-start">
                                        {btn.label}
                                   </div>
                              </div>
                         </div>
                    ))
               }
               <div className="bottom-box w-100">
                    {userAccount.security === 'Admin' && (
                         <div className="bottom-button bg-light text-dark w-100 d-flex align-items-center" onClick={() => setTheSideButton('Users')}>
                              <div className="col-14">
                                   <img src={lgoGroup} alt="" height="35px" />
                              </div>
                              <div className="flex-grow-1 text-start">
                                   Manage Users
                              </div>
                         </div>
                    )}
                    <div className="bottom-button bg-navy text-light w-100 d-flex align-items-center" onClick={() => setTheSideButton('Account')}>
                         <div className="col-14">
                              <img src={accountIcon} alt="" height="35px" />
                         </div>
                         <div className="flex-grow-1 text-start">
                              My Account
                         </div>
                    </div>
               </div>
          </div>
     );


}

export default SideBar;